export default "__VITE_ASSET__BvcXiITr__"